import { useContext, useEffect } from 'react';
import { FieldValues, UseFormSetError } from 'react-hook-form';

import UiContext from 'common/UiContext/UiContext';

const useFormApiErrors = (
  isError: boolean,
  error: Record<string, Record<string, Array<string>>>,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setError: UseFormSetError<FieldValues>,
  isSuccess?: boolean,
  successMessage?: string,
): void => {
  const { addToast } = useContext(UiContext);

  useEffect(() => {
    if(isError){
      Object.entries(error.data).forEach(([field, value]) => {
        if('non_field_errors' === field) {
          value.forEach((msg) => {
          addToast!(msg, 'Error');
          });
        } else {
            addToast!(value[0], 'Error');
          // setError( f, { message: v[0] } )
        }
      });
    }
  }, [isError]);

  useEffect(() => {
    if(isSuccess){
      addToast!(successMessage ?? 'Data updated successfully');
    }
  }, [isSuccess]);
};

export default useFormApiErrors;
